 <template id="template-input">
  <div
    :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
    :class="isPreview ? 'pb-2 mb-2' : 'bg-light p-3 pb-5 mb-2'"
  >
    <!-- menu buttons -->
    <MenuButtons
      v-if="!isPreview"
      :fieldData="fieldData"
      :collapse="collapse"
      :isHidden="isHidden"
      :label="label"
      :sectionIndex="sectionIndex"
      :fieldIndex="fieldIndex"
      v-on:toggle-field="showSettings=!showSettings"
      v-on:collapse-field="collapse=!collapse"
    />

    <!-- input content -->
    <b-collapse
      v-show="JSON.parse(!fieldData.isHidden) || !isPreview"
      id="collapse-1"
      :class="isPreview ? 'mt-0': 'mt-5'"
      v-model="collapse"
    >
      <b-col
        cols="12"
        class="text-left"
        v-if="fieldData.isReadOnly && isActive"
      >
      <vue-editor
          :class="$store.state.rightAlign ? 'text-right htmleditor' : 'text-left htmleditor'"
          :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
          v-model="fieldData.label[selectedLanguage]"
          :disabled="true"
          :editorOptions="editorOptions"
        />
        <!-- <div
          v-html="fieldData.label[selectedLanguage]"
          :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
          :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
        /> -->
      </b-col>
      <b-col
        cols="12"
        class="text-left"
        v-else
      >
        <vue-editor
          :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
          :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
          v-model="fieldData.label[selectedLanguage]"
        />
      </b-col>
    </b-collapse>

    <b-modal
      ok-only
      ok-title="Close"
      size="lg"
      v-model="showSettings"
      scrollable
      title="Paragraph Settings"
    >
      <AdvanceHeadingSettings
        :fieldData="fieldData"
        v-on:toggle-field="showSettings=!showSettings"
        :sectionIndex="sectionIndex"
        :fieldIndex="fieldIndex"
      />
    </b-modal>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor"
import { required } from "vuelidate/lib/validators";
import AdvanceHeadingSettings from "../advanceHeadingSettingsComponent";
import MenuButtons from "../menuButtons";
import { mapGetters, mapState } from "vuex";
import Cryptr from "cryptr";
export default {
  name: "WyswgGroup",
  components: {
    AdvanceHeadingSettings,
    MenuButtons,
    VueEditor
  },
  data () {
    return {
      isHidden: false,
      isActive:0,
      label: undefined,
      collapse: true,
      showSettings: false,
      editorOptions : {
        modules: {
          toolbar: false,
        },
      }
    };
  },
  mounted () {
    this.label = this.fieldData.label[this.selectedLanguage];
    const cryptr = new Cryptr("myTotalySecretKey");
    const decryptedString = cryptr.decrypt(localStorage.getItem('formStatus'));
    this.isActive = parseInt(decryptedString) || 0;
  },
  computed: {
    ...mapGetters( ["form1", "selectedLanguage"] ),
    ...mapState( ["toggleAllCoppalse"] )
  },
  watch: {
    toggleAllCoppalse ( value ) {
      this.collapse = value;
    }
  },
  methods: {
    setValue ( e ) {
      //this.h1Name = e;
      this.fieldData.label[this.selectedLanguage] = this.label;
    }
  },
  props: {
    fieldData: Object,
    isPreview: Boolean,
    sectionIndex: Number,
    fieldIndex: Number
  }
};
</script>
<style>
.ql-container.ql-snow.ql-disabled {
  border: 0px solid #ccc;
}
div.htmleditor > .ql-toolbar.ql-snow {
  visibility: hidden;
  display: none;
}
</style>
<style scoped>
.custom-input-tag-h1 {
  background-color: transparent;
  height: 60px;
  font-size: 36px;
  border: 0;
  width: auto;
}
.custom-input-tag-h2 {
  background-color: transparent;
  height: 50px;
  font-size: 26px;
  border: 0;
  width: auto;
}
.custom-input-tag-h3 {
  background-color: transparent;
  height: 40px;
  font-size: 20px;
  border: 0;
  width: auto;
}
</style>
